export function eventToPromise(target, name) {
	return new Promise((resolve, reject) => {
		const handler = event => {
			target.removeEventListener(name, handler);
			resolve(event);
		};

		target.addEventListener(name, handler);
	});
}

export async function downscaleImage(imageURL, contentType, maxSize) {
	const image = document.createElement('img');
	const imageLoadPromise = eventToPromise(image, 'load');

	image.src = imageURL;

	await imageLoadPromise;

	const canvas = document.createElement('canvas');

	canvas.height = image.height > image.width ? maxSize : ~~(image.height / image.width * maxSize);
	canvas.width = image.width > image.height ? maxSize : ~~(image.width / image.height * maxSize);
	canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);

	const dataURL = canvas.toDataURL(contentType);

	return dataURL;
}